// Terms pass B — notice wording: reviewers edit, platform admin approves (hash-locked) and test-sends.
import { useState } from "react";
import { Card, btn, call, errText, ghost, inp } from "./shared";

function ApprovalBadge({ c }) {
  const ok = c.approval_label === "APPROVED";
  return (
    <span className={`text-xs font-bold px-2 py-0.5 rounded ${ok ? "bg-[#e7f6ef] text-[#0e6b52]" : "bg-[#fdecec] text-[#b91c1c]"}`} data-testid="notice-approval-label">
      {c.approval_label}{ok ? ` · ${c.approved_by}` : c.approved_hash ? " · edited since approval" : ""}
    </span>
  );
}

function TestSend({ slug, c }) {
  const [to, setTo] = useState("");
  const [msg, setMsg] = useState(null);
  const run = async () => {
    setMsg(null);
    try { const r = await call("post", "/campaign/test-send", slug, { to: to || null }); setMsg(`Test ${r.status}.`); }
    catch (e) { setMsg(errText(e)); }
  };
  return (
    <div className="flex gap-2 items-center flex-wrap border-t border-[#f1f2f4] pt-3">
      <input className={`${inp} w-64`} placeholder="Platform admin email (blank = you)" value={to} onChange={(e) => setTo(e.target.value)} data-testid="notice-test-to" />
      <button className={ghost} onClick={run} data-testid="notice-test-send">Send test</button>
      <span className="text-xs text-[#6b7280]">Not counted in the campaign. {c.test_sends} test(s) so far.</span>
      {msg && <span className="text-xs" data-testid="notice-test-msg">{msg}</span>}
    </div>
  );
}

export function NoticeWording({ slug, c, perms, onChange }) {
  const [f, setF] = useState({ notice_subject: c.notice_subject, notice_body: c.notice_body, notice_end_date: c.notice_end_date, notice_apply_link: c.notice_apply_link });
  const [err, setErr] = useState(null);
  const edit = perms.can_review;
  const dirty = Object.keys(f).some((k) => f[k] !== c[k]);
  const act = async (fn) => { setErr(null); try { onChange(await fn()); } catch (e) { setErr(errText(e)); } };
  const field = (k, label, props = {}) => (
    <label className="block text-xs text-[#374151]">{label}
      <input className={`${inp} w-full`} value={f[k]} disabled={!edit} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`notice-${k}`} {...props} /></label>
  );
  return (
    <Card title="Notice wording" right={<ApprovalBadge c={c} />} testId="notice-wording">
      {field("notice_subject", "Subject")}
      <label className="block text-xs text-[#374151]">Body — placeholders {"{company}"}, {"{apply_link}"}, {"{end_date}"}
        <textarea className={`${inp} w-full font-mono`} rows={8} value={f.notice_body} disabled={!edit} onChange={(e) => setF({ ...f, notice_body: e.target.value })} data-testid="notice-notice_body" /></label>
      <div className="grid sm:grid-cols-2 gap-3">{field("notice_end_date", "End date (YYYY-MM-DD)")}{field("notice_apply_link", "Apply link")}</div>
      <div className="flex gap-2 items-center flex-wrap">
        {edit && <button className={btn} disabled={!dirty} onClick={() => act(() => call("put", "/campaign", slug, f))} data-testid="notice-save">Save wording</button>}
        {perms.is_platform_admin && <button className={btn} disabled={dirty || c.approval_label === "APPROVED"} onClick={() => act(() => call("post", "/campaign/approve", slug, { wording_hash: c.current_hash }))} data-testid="notice-approve">Approve this wording</button>}
        {dirty && <span className="text-xs text-[#a16207]">Save before approving.</span>}
        {err && <span className="text-xs text-[#b91c1c]" data-testid="notice-error">{err}</span>}
      </div>
      {perms.is_platform_admin && <TestSend slug={slug} c={c} />}
    </Card>
  );
}
